export default "__VITE_ASSET__cb9066b7__"